"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _helpButton = _interopRequireDefault(require("../../../core/help-button"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _calendarTable = _interopRequireDefault(require("./calendar-table"));
var _fullWidth = _interopRequireDefault(require("../../../root/full-width"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _calendarKey = _interopRequireDefault(require("./calendar-key"));
var _createCalendar = _interopRequireDefault(require("./create-calendar"));
var _addCalendarDate = _interopRequireDefault(require("./add-calendar-date"));
var _deadlinesAndRaces = _interopRequireDefault(require("./deadlines-and-races"));
var _applying = _interopRequireDefault(require("../help/applying"));
var _pdfButton = _interopRequireDefault(require("../../../core/pdf-button"));
var _exportButton = _interopRequireDefault(require("../../../core/export-button"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _ApplicationsMap = _interopRequireDefault(require("./ApplicationsMap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, {
  showName: "Help on Applying"
}, /*#__PURE__*/_react.default.createElement(_applying.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This calendar is not available for applications yet. Please come back later");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "The calendar is not open for applications yet. Please come back later");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Calendar has been finalised and gone to printers - no further amendments can be made here. You can still add Div 4s by application to the slalom committee.");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Calendar has been approved. Detailed information can still be updated, but you cannot make a new application or change dates.");
var _ref6 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Calendar is closed for new applications.");
var _ref7 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Click on the start date to add a competition.");
var _ref8 = /*#__PURE__*/_react.default.createElement("p", null, "Click on a competition to see more information");
class Calendar extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isEditingCalendar: false,
      addingCalendarDate: false,
      showOnMap: false
    });
    _defineProperty(this, "_onToggleMapView", () => {
      return this.setState({
        showOnMap: !this.state.showOnMap
      });
    });
    _defineProperty(this, "_toggleEditingCalendar", () => {
      this.setState({
        isEditingCalendar: !this.state.isEditingCalendar
      });
    });
    _defineProperty(this, "_toggleAddingCalendarDate", () => {
      this.setState({
        addingCalendarDate: !this.state.addingCalendarDate
      });
    });
  }
  render() {
    const calendar = this.props.calendar;
    const userIsCalendarOfficer = this.props.userIsCalendarOfficer;
    const userIsSystemAdmin = this.props.userIsSystemAdmin;
    const today = new Date().toISOString().split('T')[0];
    const riskAssessmentMessage = 'Competitions marked with an "R" have outstanding Risk Assessments.';
    const userCanEditCalendar = this.props.userIsCalendarOfficer && this.props.calendar && !this.state.showOnMap && (!this.props.calendar.finalisedDate || this.props.calendar.finalisedDate > today);
    return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_exportButton.default, {
      name: "calendar",
      args: {
        calendarID: +this.props.match.params.yearID
      }
    }, "Download CSV"), /*#__PURE__*/_react.default.createElement(_pdfButton.default, {
      name: "calendar",
      args: {
        calendarID: +this.props.match.params.yearID
      },
      type: "primary"
    }, "Download PDF")), _ref, !userIsSystemAdmin ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleMapView
    }, "Show/Hide Map")), !userCanEditCalendar ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleEditingCalendar
    }, "Edit Base Calendar"), this.state.showOnMap ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ApplicationsMap.default, {
      userIsCalendarOfficer: this.props.userIsCalendarOfficer,
      calendar: this.props.calendar
    })) : !calendar ? userIsSystemAdmin ? /*#__PURE__*/_react.default.createElement(_createCalendar.default, {
      yearID: +this.props.match.params.yearID
    }) : _ref2 : /*#__PURE__*/_react.default.createElement("div", null, !this.state.isEditingCalendar ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleAddingCalendarDate
    }, "Add Date"), !this.state.addingCalendarDate ? null : /*#__PURE__*/_react.default.createElement(_addCalendarDate.default, {
      calendar: calendar,
      onCloseCancel: this._toggleAddingCalendarDate
    })), (!calendar.publishDate || calendar.publishDate > today) && !userIsCalendarOfficer ? _ref3 : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      md: 4,
      lg: 5
    }, calendar.finalisedDate <= today ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "success"
    }, _ref4, /*#__PURE__*/_react.default.createElement("p", null, riskAssessmentMessage)) : calendar.approvalDate <= today ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "warning"
    }, _ref5, /*#__PURE__*/_react.default.createElement("p", null, riskAssessmentMessage)) : calendar.closingDate <= today ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, _ref6, /*#__PURE__*/_react.default.createElement("p", null, riskAssessmentMessage)) : /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "info"
    }, _ref7, _ref8, /*#__PURE__*/_react.default.createElement("p", null, riskAssessmentMessage))), /*#__PURE__*/_react.default.createElement(_col.default, {
      md: 8,
      lg: 7
    }, /*#__PURE__*/_react.default.createElement(_deadlinesAndRaces.default, {
      defaultTiers: this.props.defaultTiersByYear,
      calendar: this.props.calendar,
      today: today,
      nationRefs: this.props.nationRefs
    }))), /*#__PURE__*/_react.default.createElement(_calendarTable.default, {
      calendar: calendar,
      defaultTiers: this.props.defaultTiersByYear,
      userIsCalendarOfficer: this.props.userIsCalendarOfficer,
      isEditingCalendar: this.state.isEditingCalendar
    }), /*#__PURE__*/_react.default.createElement(_calendarKey.default, {
      applicationStatusRefs: this.props.applicationStatusRefs
    })))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
// TODO applicationRacing section is for Applications Map but is not being picked up properly by ApplicationsMap.partialQueries
var _ref9 = _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
  id: true,
  publishDate: true,
  closingDate: true,
  approvalDate: true,
  finalisedDate: true,
  applicationRacing: {
    id: true,
    isRaceStartDay: true,
    tierRef: true,
    application: {
      id: true,
      site: {
        id: true,
        location: true,
        abbreviation: true,
        latitude: true,
        longitude: true
      }
    }
  }
}, _calendarTable.default.partialQueries.Calendar), _deadlinesAndRaces.default.partialQueries.Calendar), _ApplicationsMap.default.partialQueries.Calendar), _addCalendarDate.default.partialQueries.Calendar);
var _ref10 = _mergeBqlQueries(_mergeBqlQueries({}, _calendarTable.default.partialQueries.DefaultTiers), _deadlinesAndRaces.default.partialQueries.DefaultTiers);
var _ref11 = _mergeBqlQueries({}, _calendarKey.default.partialQueries.ApplicationStatusRef);
var _ref12 = _mergeBqlQueries({}, _deadlinesAndRaces.default.partialQueries.NationRef);
var _default = exports.default = (0, _reactBicycle.connect)(Calendar, props => ({
  userIsCalendarOfficer: true,
  userIsSystemAdmin: true,
  ["calendar(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref9,
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref10,
  "refCodes(codeType:\"applicationstatus\") as applicationStatusRefs": _ref11,
  "refCodes(codeType:\"nation\") as nationRefs": _ref12
}));